export const toTitleCase = (word: string) =>
  word[0].toUpperCase() + word.slice(1).toLowerCase()

export const addCommasToNumber = (num: number) =>
  String(num).replace(/(.)(?=(\d{3})+$)/g, '$1,')

export const joinWithCommasAndLastAnd = (strings: string[]) => {
  if (strings.length === 0) return ''
  else if (strings.length === 1) return `${strings[0]}`
  const joinedWithoutLast = [...strings].slice(0, strings.length - 1).join(', ')
  const lastString = strings[strings.length - 1]
  return `${joinedWithoutLast}, and ${lastString}`
}

export const formatPhoneNumber = (phoneNumber: string) =>
  phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '+1-$1-$2-$3')
